import React, { useMemo } from 'react';
import { useProjectState } from '@starflow/app/store';
import { registerType } from '../../../../constants';
import ShortHeader from './ShortHeader';
import UnitLists from './UnitLists';
import FlowLists from './FlowLists';

const FlowFold = React.memo(() => {
  const currentNodeId = useProjectState('currentNodeId');
  const nodeMap = useProjectState('nodeMap');
  const units = useProjectState('units');
  const flows = useProjectState('flows');
  const typeInfos = useMemo(() => {
    const type = nodeMap[currentNodeId]?.registerType;
    let flow = {};
    if (type !== registerType.UNIT) {
      let flowId = '';
      flows.forEach((flow) => {
        if (flow.data.nodes.some((node) => node === currentNodeId)) {
          flowId = flow.flowId;
        }
      });
      flow = flows.find((flow) => flow.flowId === flowId);
    }
    return {
      type,
      units: type === registerType.UNIT ? units.nodes.map((node) => nodeMap[node]) : [],
      flow,
    };
  }, [nodeMap, currentNodeId]);
  return (
    <div className="h-full overflow-hidden">
      <ShortHeader />
      <div className="h-full overflow-auto">
        {typeInfos.type === registerType.UNIT ? (
          typeInfos.units?.length ? (
            <UnitLists data={typeInfos.units} />
          ) : (
            <span>数据异常</span>
          )
        ) : typeInfos.flow?.nodeOrderList?.length ? (
          <FlowLists data={typeInfos.flow} />
        ) : null}
      </div>
    </div>
  );
});

export default FlowFold;
